import {
  fetchLocationStart,
  fetchLocationSuccess,
  fetchLocationFailure,
} from "./reducer"; // adjust path if needed

import { determineBaseUrlAndPerformApiCall } from "../../interceptor/interceptor";
import { GET_ALL_LOCATION } from "../../constants/constants";

export const getAllLocation = (setLoading) => async (dispatch) => {
  try {
    setLoading(true);
    dispatch(fetchLocationStart());

    const response = await determineBaseUrlAndPerformApiCall(
      GET_ALL_LOCATION,
      "GET"
    );

    setLoading(false);
    dispatch(fetchLocationSuccess(response));
  } catch (error) {
    setLoading(false);
    dispatch(fetchLocationFailure(error.message));
  }
};
